/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Days_WordsInputs */

const en_us2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days week frequency monday tuesday wednesday thursday friday saturday sunday`)
};

const pt_br2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias semana frequencia segunda terca quarta quinta sexta sabado domingo`)
};

const es_419_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias semana frecuencia lunes martes miercoles jueves viernes sabado domingo`)
};

const pt_pt2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dias semana frequencia segunda terca quarta quinta sexta sabado domingo`)
};

const fr_fr2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jours semaine frequence lundi mardi mercredi jeudi vendredi samedi dimanche`)
};

const de_de2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tage woche häufigkeit montag dienstag mittwoch donnerstag freitag samstag sonntag`)
};

const it_it2_search_field_days_words = /** @type {(inputs: Search_Field_Days_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giorni settimana frequenza lunedi martedi mercoledi giovedi venerdi sabato domenica`)
};

/**
* | output |
* | --- |
* | "days week frequency monday tuesday wednesday thursday friday saturday sunday" |
*
* @param {Search_Field_Days_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_days_words = /** @type {((inputs?: Search_Field_Days_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Days_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_days_words(inputs)
	if (locale === "es-419") return es_419_search_field_days_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_days_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_days_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_days_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_days_words(inputs)
	return en_us2_search_field_days_words(inputs)
});
export { search_field_days_words as "search.field_days_words" }